import { render, staticRenderFns } from "./openingSteps.vue?vue&type=template&id=a2197006&scoped=true"
import script from "./openingSteps.vue?vue&type=script&lang=js"
export * from "./openingSteps.vue?vue&type=script&lang=js"
import style0 from "./openingSteps.vue?vue&type=style&index=0&id=a2197006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2197006",
  null
  
)

export default component.exports